import React, { useEffect, useState } from 'react';
import { Card, ProgressBar } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressBook, faBullseye, faTrophy, faAppleAlt } from '@fortawesome/free-solid-svg-icons';
import GoalService from './goals/GoalService';

const GoalProgressCard = ({ data }) => {
  const [goals, setGoals] = useState();
  const getCategoryIcon = (category) => {
    switch (category) {
      case 'attendance':
        return faAddressBook;
      case 'skill':
        return faBullseye;
      case 'benchmark':
        return faTrophy;
      case 'nutrition':
        return faAppleAlt;
      default:
        return faAddressBook;
    }
  };

  const getProgressVariant = (percentage) => {
    if (percentage >= 80) return 'success';
    if (percentage >= 50) return 'warning';
    return 'info';
  };
  useEffect(() => {
    GoalService.retrieveGoalsByUser().then(data => {
        console.log('Data Goals', data);
        setGoals(data);
      })
      .catch(error => {
        console.error('Error retrieving Goals', error);
      });

  }, []);
  return (
    <Card className="h-100 isDark border-0 shadow-sm wod-dark-card">
      <Card.Header className="bg-transparent border-bottom border-secondary">
        <h5 className="mb-0 fw-bold">Goal Progress</h5>
      </Card.Header>
      <Card.Body>
        <>
        {!goals || goals.length === 0 ? (
          <div className="text-center p-3 text-white-50">
            No goals to show yet.
          </div>
        ) : (
        <div className="d-flex flex-column gap-4">
          {goals?.map((goal) => (
            <div key={goal.identifier}>
              <div className="d-flex justify-content-between align-items-start mb-2">
                <div className="d-flex align-items-start">
                  <FontAwesomeIcon
                    icon={getCategoryIcon(goal.category)}
                    className="text-warning me-2 mt-1"
                  />
                  <div>
                    <div className="fw-semibold">{goal.name}</div>
                    {goal.description && (
                      <small className="text-white-50">{goal.description}</small>
                    )}
                  </div>
                </div>
                <span className="fw-bold text-warning">{goal.percentage}%</span>
              </div>
              <ProgressBar
                now={goal.percentage}
                variant={getProgressVariant(goal.percentage)}
                className="mb-1"
                style={{ height: '8px' }}
              />
              <div className="d-flex justify-content-between">
                <small className="text-white-50">
                  {goal.current} / {goal.targetValue} {goal.unit || ''}
                </small>
                {goal.type !== 'lifetime' && (<small className="text-white-50">
                  Due: {new Date(goal.deadline).toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric'
                  })}
                </small>)}
              </div>
            </div>
          ))}
        </div>
        )}
        </>
      </Card.Body>
    </Card>
  );
};

export default GoalProgressCard;
